import { useContext } from "~/stores/context.js";

export default defineNuxtRouteMiddleware(async (to) => {
  const context = useContext();

  if (
    to.path.startsWith("/setup") ||
    to.path === "/login" ||
    to.path === "/settlement"
  ) {
    return;
  }

  if (context.hasClosingError) {
    return navigateTo("/settlement");
  }
});
